import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import type { SwissCategory } from '../types'
import {
  swissCategoryColor,
  swissCategoryLabel,
  swissCategoryCompactLabel,
  type SwissCategoryColor
} from '../utils/swiss-category-label'

interface Options {
  // На мобилке используем компактный заголовок («Прошли дальше» / «Выбыли»),
  // на десктопе — полный («3-1, 3-2»). См. mockups (functional/15-mockups.md).
  compactMode?: MaybeRefOrGetter<boolean>
}

interface SwissCategoryMeta {
  label: string
  color: SwissCategoryColor
  // true — для категории «3-0» / «прошли дальше» можно показать иконку победы.
  isAdvancing: boolean
  // true — категория «выбыли», UI может рисовать «крестик».
  isEliminated: boolean
}

export const useSwissCategoryMeta = (
  category: MaybeRefOrGetter<SwissCategory>,
  options: Options = {}
) => {
  const meta = computed<SwissCategoryMeta>(() => {
    const cat = toValue(category)
    const compact = toValue(options.compactMode) === true
    const label = compact
      ? swissCategoryCompactLabel(cat)
      : swissCategoryLabel(cat)
    const color = swissCategoryColor(cat)

    return {
      label,
      color,
      isAdvancing: cat.losses.length === 0,
      isEliminated: cat.wins.length === 0
    }
  })

  return { meta }
}
